import {createBrowserRouter, Navigate} from 'react-router'
import { MainPage } from './pages/application/main'
import { ExtensionLogin } from './pages/application/extensionLogin'
import Login from './pages/application/Login'
import React, {useEffect} from "react";
import {APITable, APIUsage, ScanPage} from "./pages/application/main/scanPage";
import {PremiumPage} from "./pages/application/main/PremiumPage";
import {Britishizer} from "./pages/application/main/britishizer";
import HistoryPage from "./pages/application/main/history";
import { useNavigate } from "react-router";

const OpenDocs = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.open('https://docs.its-ai.org')
        navigate('/main/api')
    })
    return <></>
}

export const appRouter = createBrowserRouter([
    {
        path: '/',
        element: <Navigate to="/main/scan" replace />
    },
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/main',
        element: <MainPage><ScanPage/></MainPage>
    },
    {
        path: '/main/scan',
        element: <MainPage><ScanPage/></MainPage>
    },
    {
        path: '/main/britishizer',
        element: <MainPage><Britishizer/></MainPage>
    },
    {
        path: '/main/api',
        element: <Navigate to="/main/api/table" replace />
    },
    {
        path: '/main/subscription',
        element: <MainPage ><PremiumPage/></MainPage>
    },
    {
        path: '/main/statistics',
        element: <MainPage><APIUsage/></MainPage>
    },
    {
        path: '/main/api/table',
        element: <MainPage ><APITable/></MainPage>
    },
    {
        path: '/main/api/table',
        element: <MainPage ><APITable/></MainPage>
    },
    {
        path: '/main/api/docs',
        element: <OpenDocs/>
    },
    {
        path: '/main/history',
        element: <MainPage ><HistoryPage/></MainPage>
    },
    {
        path: '/extension',
        element: <ExtensionLogin />
    }
])

export default appRouter;